import { createPushModal } from 'pushmodal';
import { AddOfficeSheet } from './add-office-sheet';
import { AddOfficeWorkScheduleSlotSheet } from './add-office-work-schedule-slot-sheet/add-office-work-schedule-slot-sheet';
import { OpenOfficeAgendaSlotSheet } from './open-office-agenda-slot-sheet/open-office-agenda-slot-sheet';
import { ViewAdminAgendaSlotSheet } from './view-admin-agenda-slot-sheet/view-admin-agenda-slot-sheet';
import { ViewAdminWorkScheduleSlotSheet } from './view-admin-work-schedule-slot-sheet/view-admin-work-schedule-slot-sheet';
import { ViewProfileSheet } from './view-profile-sheet/view-profile-sheet';
import { ViewUserAgendaSlotSheet } from './view-user-agenda-slot-sheet/view-user-agenda-slot-sheet';
import { ViewUserWorkScheduleSlotSheet } from './view-user-work-schedule-slot-sheet/view-user-work-schedule-slot-sheet';

export const {
  pushModal: pushSheet,
  popModal: popSheet,
  popAllModals: popAllSheets,
  replaceWithModal: replaceWithSheet,
  useOnPushModal: useOnPushSheet,
  onPushModal: onPushSheet,
  ModalProvider: SheetProvider,
} = createPushModal({
  modals: {
    ViewProfileSheet,
    AddOfficeSheet,
    OpenOfficeAgendaSlotSheet,
    ViewAdminAgendaSlotSheet,
    ViewUserAgendaSlotSheet,
    AddOfficeWorkScheduleSlotSheet,
    ViewAdminWorkScheduleSlotSheet,
    ViewUserWorkScheduleSlotSheet,
  },
});
export type SheetNames = Parameters<typeof popSheet>[0];
